import React from 'react';

import debug from '@fastlessjs/backoffice-layer/dist/utils/debug';
import { Tag } from 'antd';

import { t } from '../../config/translations';
import {
  formatProcessingStatusLabel,
  getProcessingStatusTagColor,
} from '../utils/traceStatusDisplay';

debug.registerComponent('ProcessingStatusTag');

const processingStatusLabels = () => ({
  pending: t('trace.processingStatus.pending'),
  unavailable: t('trace.processingStatus.unavailable'),
});

type ProcessingStatusTagProps = {
  status: string | undefined;
};

export const ProcessingStatusTag = ({ status }: ProcessingStatusTagProps) => {
  const label = formatProcessingStatusLabel(status, processingStatusLabels()) || status;
  if (!label) {
    return <span>—</span>;
  }
  return <Tag color={getProcessingStatusTagColor(status)}>{label}</Tag>;
};

debug.markInitialized('ProcessingStatusTag');
